
import { LangType, Translations } from '../types/language';
import en from './en.json';
import fr from './fr.json';

const translations: Translations = { en, fr };

export const translation = (lang: LangType, key: string): string => {
  return translations[lang][key] || translations['en'][key];
};
